<template>
    <div class="inall">
      <div>
        <div class="tp1">
            <div>
              <b-img :src="require('@/assets/banner04_2new_720.png')" class="tp1-image" />
            </div>             
        </div>
        <div class="tp1_add">
          <div class="tp1_add_left"></div>
          <div class="tp1_add_mid">
            <div class="tp1_add_mid_title">On Call Smart Pro</div>
            <div class="tp1_add_mid_1" style="display: flex;">
              <div class="tp1_add_mid_1_1">Blood Glucose Analyzer</div>
              <div class="tp1_add_mid_1_icon"><b-img :src="require('@/assets/inhos_line.png')" class="tp1_add_icon" /></div>
              <div class="tp1_add_mid_1_2">Ketone Analyzer</div>
              <div class="tp1_add_mid_1_icon"><b-img :src="require('@/assets/inhos_line.png')" class="tp1_add_icon" /></div>
              <div class="tp1_add_mid_1_3">Uric Acid Analyzer</div>
              <div class="tp1_add_mid_1_icon"><b-img :src="require('@/assets/inhos_line.png')" class="tp1_add_icon" /></div>
              <div class="tp1_add_mid_1_4">Data Management Platform</div>
            </div>
            <div class="tp1_add_mid_2" style="display: flex;">
              <div class="tp1_add_mid_2_1">
                <div class="tp1_add_mid_2_1_img"><b-img :src="require('@/assets/inhosaddicon_1.png')" class="tp1_add_icon2" /></div>
                <div class="tp1_add_mid_2_1_title">Integration</div>
              </div>
              <div class="tp1_add_mid_2_2" style="margin-left: 48px; margin-right: 40px;">
                <div class="tp1_add_mid_2_2_img"><b-img :src="require('@/assets/inhosaddicon_2.png')" class="tp1_add_icon2" /></div>
                <div class="tp1_add_mid_2_2_title">Digitalization</div>
              </div>
              <div class="tp1_add_mid_2_3">
                <div class="tp1_add_mid_2_3_img"><b-img :src="require('@/assets/inhosaddicon_3.png')" class="tp1_add_icon2" /></div>
                <div class="tp1_add_mid_2_3_title">Intelligentialize</div>
              </div>
            </div>
          </div>
          <div class="tp1_add_right"></div>
        </div>
        <div class="t1">
          <div class="t1_left"></div>
          <div class="t1_mid">
            <div class="t1_1" style="margin-top: 22px;">
              <div class="t1_1_2">
                <div class="t1_1_2_1">
                  <div class="t1_1_2_1_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_1_d">Stable data transfer<br>
                    (Wifi 2.4G/5G , BLUETOOTH , Type-C USB , LIS/HIS)</div>
                </div>
                <div class="t1_1_2_2">
                  <div class="t1_1_2_2_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_2_d">Accurate and reliable test  results</div>
                </div>
                <div class="t1_1_2_3">
                  <div class="t1_1_2_3_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_3_d">3 Test items (blood glucose/ketone/uric acid) 3 test strips 
                    compatible </div>
                </div>
                <div class="t1_1_2_4">
                  <div class="t1_1_2_4_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_4_d">Support split screen test and multiple parameters 
                    simultaneously</div>
                </div>
                <div class="t1_1_2_5">
                  <div class="t1_1_2_5_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_5_d">Large display for easy reading </div>
                </div>
                <div class="t1_1_2_6">
                  <div class="t1_1_2_6_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_6_d">USB or charging hub charging</div>
                </div>
                <div class="t1_1_2_7">
                  <div class="t1_1_2_7_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_7_d">Strip ejector to avoid cross contamination</div>
                </div>
                <div class="t1_1_2_8">
                  <div class="t1_1_2_8_i"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                  <div class="t1_1_2_8_d">Customizable functional mudule</div>
                </div>
              </div>
            </div>
            <div class="t1_2">
              <b-img :src="require('@/assets/000.png')" class="tp1-image-1" />
            </div>
          </div>
          <div class="t1_right"></div>
        </div>

        <div class="tp1_add_2">
          <div class="tp1_add_2_left"></div>
          <div class="tp1_add_2_mid">
            <div class="tp1_add_2_mid_1">
              <div class="tp1_add_2_mid_1_title">Streamline diabetes managent by a seamless integration with HIS/EMR</div>
              <div class="tp1_add_2_mid_1_sub">Our on call smart pro diabetes management systerm can integrate with the HIS (Hospital information system) or EMR(Electronic medical records) to streamline diabetes mangement, reduce workload, and enable data to be accessed, analyzed ,and shared securely and appropriately across the complete spectrum of healthcare</div>
            </div>
            <div class="tp1_add_2_mid_2">
              <div class="tp1_add_2_mid_2_title">HIS integration:</div>
              <div class="tp1_add_2_mid_2_subpart1">
                  <div class="tp1_add_2_mid_2_subpart1_title">1. database-to-database integration</div>
                  <div class="tp1_add_2_mid_2_subpart1_sub1" style="display: flex; align-items: center; margin-left: 20px;">
                    <div class="tp1_add_2_mid_2_subpart1_sub1_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                    <div class="tp1_add_2_mid_2_subpart1_sub1_cont" style="margin-left: 8px;">supported databases: oracle, MySQL, Microsoft SQL Server, PostgreSQL, MongoDB</div>
                  </div>
                  <div class="tp1_add_2_mid_2_subpart1_sub2" style="display: flex; align-items: center; margin-left: 20px;">
                    <div class="tp1_add_2_mid_2_subpart1_sub2_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                    <div class="tp1_add_2_mid_2_subpart1_sub2_cont" style="margin-left: 8px;">Integration Methods: Direct database connection for real-time data synchronization</div>
                  </div>
              </div>
              <div class="tp1_add_2_mid_2_subpart2">
                  <div class="tp1_add_2_mid_2_subpart2_title">2. API-to-API Integration</div>
                  <div class="tp1_add_2_mid_2_subpart2_sub1" style="display: flex; align-items: center; margin-left: 20px;">
                    <div class="tp1_add_2_mid_2_subpart2_sub1_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                    <div class="tp1_add_2_mid_2_subpart2_sub1_cont" style="margin-left: 8px;">Integration Methods: RESTful API, WebService, SOAP ,GraphQL</div>
                  </div>
                  <div class="tp1_add_2_mid_2_subpart2_sub2" style="display: flex; align-items: center; margin-left: 20px;">
                    <div class="tp1_add_2_mid_2_subpart2_sub2_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                    <div class="tp1_add_2_mid_2_subpart2_sub2_cont" style="margin-left: 8px;">Data format : JSON, XML</div>
                  </div>
              </div>
            </div>
            <div class="tp1_add_2_mid_3">
              <div class="tp1_add_2_mid_3_title">EMR System integration:</div>
              <div class="tp1_add_2_mid_3_sub1" style="display: flex; align-items: center;">
                <div class="tp1_add_2_mid_3_sub1_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_3_sub1_cont" style="margin-left: 8px;">Integration protocols : HL7, FHIR</div>
              </div>
              <div class="tp1_add_2_mid_3_sub2" style="display: flex; align-items: center;">
                <div class="tp1_add_2_mid_3_sub2_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_3_sub2_cont" style="margin-left: 8px;">Supported EMR Systems : Oracle Cemer, Epic Systems, Allscripts, Meditech</div>
              </div>
              <div class="tp1_add_2_mid_3_sub3" style="display: flex; align-items: center;">
                <div class="tp1_add_2_mid_3_sub3_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_3_sub3_cont" style="margin-left: 8px;">Features: Standardized protocols and data formats ensure secure data transmission and seamless exchange , real-time updates , and flexible data querying</div>
              </div>
            </div>
            <div class="tp1_add_2_mid_4">
              <div class="tp1_add_2_mid_4_title">Benefits of integration</div>
              <div class="tp1_add_2_mid_4_sub1" style="display: flex; align-items: center;">
                <div class="tp1_add_2_mid_4_sub1_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_4_sub1_cont" style="margin-left: 8px;">Enhanced patient Management : real-time access to comprehensive patient data improves decision-making and management.</div>
              </div>
              <div class="tp1_add_2_mid_4_sub2" style="display: flex; align-items: center;">
                <div class="tp1_add_2_mid_4_sub2_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_4_sub2_cont" style="margin-left: 8px;">Operational efficiency : streamlined workflows and automated data exchange reduce administrative burden and errors</div>
              </div>
              <div class="tp1_add_2_mid_4_sub3" style="display: flex; align-items: flex-start;">
                <div class="tp1_add_2_mid_4_sub3_icon"><b-img :src="require('@/assets/inhos_p8.png')" class="tp1_img" /></div>
                <div class="tp1_add_2_mid_4_sub3_cont" style="margin-left: 8px;">Coordinated healthcare : Integrated systems ensure smooth and secure information flow between HIS , EMR , and the diabetes management system , leading to more coordinated and effective healthcare across departments</div>
              </div>

            </div>
          </div>
          <div class="tp1_add_2_right"></div>
        </div>

        <div class="tp2">
          <div class="tp2_title">Core Features</div>
          <div class="tp2_sub">Our Provided Solutions Will Help You Treat With A More Comprehensive Perspective.</div>
        </div>
        <div class="tp3">
          <div class="tp3_left"></div>
          <div class="tp3_mid">
            <div class="tp3_mid_all">
              <div class="tp3_mid_d">
                <div class="tp3_mid_d_title">The Doctor Issues Medical Orders</div>
                <div class="tp3_mid_d_sub">Doctors use the platform to formulate treatment plans for patients, which facilitates tracking and auditing. After the orders are issued, they will be executed by nursing staff or other healthcare professionals. All orders are recorded in the patient's electronic medical record for easy tracking and auditing</div>
              </div>
              
            </div>
            <div class="tp3_mid_image"><b-img :src="require('@/assets/02.png')" class="large-image1"></b-img></div>
          </div>
          <div class="tp3_right"></div>
        </div>

        <div class="tp4">
          <div class="tp4_left"></div>
          <div class="tp4_mid">
            <div class="tp4_mid_image"><b-img :src="require('@/assets/inhosnewp2.png')" class="large-image2"></b-img></div>
            <div class="tp4_mid_all">
              <div class="tp4_mid_d">
                <div class="tp4_mid_d_title">Nurses Carry Out</div>
                <div class="tp4_mid_d_sub">Nurses receive doctors' orders through the platform, which include medication dosages and examination items. They perform operations such as medication administration and injections according to the specific instructions of the orders. They also record the detailed execution information in the system, including the time of execution, dosage, and patient reactions, and report to the doctor when necessary</div>
                <div class="video-container">
                  <div id="player1"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="tp4_right"></div>
        </div>

        <div class="tp3" style="margin-bottom: 240px; margin-top:120px ;">
          <div class="tp3_left"></div>
          <div class="tp3_mid">
            <div class="tp3_mid_all">
              <div class="tp3_mid_d">
                <div class="tp3_mid_d_title">Quality Control Monthly Report</div>
                <div class="tp3_mid_d_sub">Provide effective quality control records and analysis for medical staff, and automatically generate a Quality Control Monthly Report to assess and document the quality control outcomes over the month. Generate detailed monthly reports, including charts, tables, and textual explanations, for easy comprehension and analysis</div>
                <div class="video-container">
                  <div id="player2"></div>
                </div>
              </div>
              
            </div>
            <div class="tp3_mid_image"><b-img :src="require('@/assets/newinhosp02.png')" class="large-image1"></b-img></div>
          </div>
          <div class="tp3_right"></div>
        </div>
        
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InHospitalPage',
    mounted() {
      this.loadYouTubeAPI();
  },
  watch: {
    $route() {
      this.initializePlayers();
    }
  },
  methods: {
    loadYouTubeAPI() {
      if (!document.getElementById('youtube-api')) {
        const tag = document.createElement('script');
        tag.id = 'youtube-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = this.initializePlayers;
      } else {
        this.initializePlayers();
      }
    },
    initializePlayers() {
      /* eslint-disable no-undef */
      if (!this.player1) {
        this.player1 = new YT.Player('player1', {
          height: '391',
          width: '540',
          videoId: 'MUnOtVpnVIA', // 替换为你的第一个YouTube视频ID
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange
          }
        });
      }

      if (!this.player2) {
        this.player2 = new YT.Player('player2', {
          height: '301',
          width: '519',
          videoId: 'C90BdUd_XXk', // 替换为你的第二个YouTube视频ID
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange
          }
        });
      }
      /* eslint-enable no-undef */
    },
  }
  }
  </script>
  
  <style scoped>
  .inall{
    min-width: 1200px;
  }

  .tp1{
  position: relative;
  width: 100%;
  overflow: hidden;
}
.tp1-image{
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tp1_add,
.tp1_add_2{
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
}
.tp1_add_mid{
  display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}
.tp1_add_mid_title{
  font-family: Arial;
font-size: 40px;
font-weight: 700;
line-height: 48px;
margin-bottom: 26px;
margin-top: 55px;
color: #000000;
}
.tp1_add_mid_1_1,
.tp1_add_mid_1_2,
.tp1_add_mid_1_3,
.tp1_add_mid_1_4 {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
color: #000000;
}
.tp1_add_icon{
  margin-left: 12px;
  margin-right: 12px;
}
.tp1_add_mid_2_1,
.tp1_add_mid_2_2,
.tp1_add_mid_2_3 {
  display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}
.tp1_add_mid_2_1_title,
.tp1_add_mid_2_2_title,
.tp1_add_mid_2_3_title{
  font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 20.7px;
color: #000000;

}

.t1 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
  margin-top: 40px;
}

.t1_mid {
  display: grid;
  grid-template-columns: 521px 734px; /* 将中间部分划分为两列，左边521px，右边734px */
  gap: 0; /* 去掉列间距 */
}

.t1_1,
.t1_2 {
margin-top: 8px;
}

.t1_1 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 子元素在垂直方向上对齐起始位置 */
  gap: 10px; /* 子元素之间的间距 */
}


.t1_1_2 {
  display: flex;
  flex-direction: column;
  gap: 10px; /* 子元素之间的间距 */
  width: 100%; /* 确保容器宽度为100% */
}

.t1_1_2_1,
.t1_1_2_2,
.t1_1_2_3,
.t1_1_2_4,
.t1_1_2_5,
.t1_1_2_6,
.t1_1_2_7,
.t1_1_2_8 {
  display: flex;
  align-items: center;
  gap: 12px; /* 子元素之间的间距 */
  width: 431px;
  align-items: flex-start;
}

.tp1_img {
  width: 6px; /* 图像宽度 */
  height: auto;
}

.t1_1_2_1_d,
.t1_1_2_2_d,
.t1_1_2_3_d,
.t1_1_2_4_d,
.t1_1_2_5_d,
.t1_1_2_6_d,
.t1_1_2_7_d,
.t1_1_2_8_d {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: left;
color:#333333 ;
}

.tp1_image_1 {
  width: 734px; /* 图像宽度 */
  height: 459px; /* 图像高度 */
  object-fit: cover; /* 确保图片按比例填充 */
}

.tp1_add_2_mid_1_title,
.tp1_add_2_mid_2_title,
.tp1_add_2_mid_3_title,
.tp1_add_2_mid_4_title{
  font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 26px;
text-align: left;
color: #000000;
margin-top: 10px;
}

.tp1_add_2_mid_1_sub,
.tp1_add_2_mid_2_subpart1_title,
.tp1_add_2_mid_2_subpart1_sub1_cont,
.tp1_add_2_mid_2_subpart1_sub2_cont,
.tp1_add_2_mid_2_subpart2_title,
.tp1_add_2_mid_2_subpart2_sub1_cont,
.tp1_add_2_mid_2_subpart2_sub2_cont,
.tp1_add_2_mid_3_sub1_cont,
.tp1_add_2_mid_3_sub2_cont,
.tp1_add_2_mid_3_sub3_cont,
.tp1_add_2_mid_4_sub1_cont,
.tp1_add_2_mid_4_sub2_cont {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: left;
color: #555555;
margin-top: 10px;
}

.tp1_add_2_mid_4_sub3_cont {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: left;
color: #555555;
}

.tp2{
    text-align: center;
    margin-top: 67px;
  }
.tp2_title{
    font-family: Arial;
font-size: 40px;
font-weight: 700;
line-height: 48px;
color: #000;
  }
  .tp2_sub{
    font-family: Arial;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1B2944;
    margin-top: 16px;
  }

  .tp3 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */

}

.tp3_mid {
  display: grid;
  grid-template-columns: 531px 660px; /* 将中间部分划分为两列，左边531px，右边660px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp3_mid_left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 子元素在垂直方向上对齐起始位置 */
  padding: 20px; /* 添加内边距 */
}

.tp3_mid_d {
  width: 531px; /* 固定宽度 */
}

.tp3_mid_d_title {
  font-family: Arial;
font-size: 26px;
font-weight: 400;
line-height: 34px;
text-align: left;
color: #000000;
margin-bottom: 32px;
}

.tp3_mid_d_sub {
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #555555;
}

.tp3_mid_right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 660px; /* 固定宽度 */
  height: 500px; /* 固定高度 */
}

.large-image1 {
  width: 100%; /* 图像宽度 */
  height: 100%; /* 图像高度 */
  object-fit: cover; /* 确保图片按比例填充 */
}


.tp4 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */

}

.tp4_left,
.tp4_right {

}

.tp4_mid {
  display: grid;
  grid-template-columns: 531px 660px; /* 将中间部分划分为两列，左边531px，右边660px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp4_mid_left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 子元素在垂直方向上对齐起始位置 */
  padding: 20px; /* 添加内边距 */
}

.tp4_mid_d {
  width: 531px; /* 固定宽度 */
  margin-left: 100px;
}

.tp4_mid_d_title {
  font-family: Arial;
font-size: 26px;
font-weight: 400;
line-height: 34px;
text-align: left;
color: #000000;
margin-bottom: 32px;
}

.tp4_mid_d_sub {
  font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
text-align: left;
color: #555555;
}

.tp4_mid_right {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 660px; /* 固定宽度 */
  height: 500px; /* 固定高度 */
}

.large-image2 {
  width: 100%; /* 图像宽度 */
  height: 100%; /* 图像高度 */
  object-fit: cover; /* 确保图片按比例填充 */
}

.video-container {
  position: relative;
  margin: 20px 0;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

  </style>